<template>
  <div class="comission-counter">
    <div class="content">
      <span class="profile-title">Consumidor: </span>
      {{ getQuantityItemInList(commissionConsumerList) }} | R$
      <RenderMoneyColumnValue
        :value="sumColumn('comissionCalc', commissionConsumerList)"
      />
    </div>

    <div class="content">
      <span class="profile-title">Promotor</span>
      {{ getQuantityItemInList(commissionTraderList) }} | R$
      <RenderMoneyColumnValue
        :value="sumColumn('comissionCalc', commissionTraderList)"
      />
    </div>

    <div class="content">
      <span class="profile-title">Investidor</span>
      {{ getQuantityItemInList(commissionInvestorList) }} | R$
      <RenderMoneyColumnValue
        :value="sumColumn('comissionCalc', commissionInvestorList)"
      />
    </div>
  </div>
</template>

<script>
import { RenderMoneyColumnValue } from '../../../ui/render';
import { sumColumnValueByListAndColumn } from '../../../utils';

export default {
  components: { RenderMoneyColumnValue },
  props: {
    commissionList: {
      type: Array,
      default: [],
      required: true,
    },
  },
  data() {
    return {
      commissionInvestorList: [],
      commissionTraderList: [],
      commissionConsumerList: [],
    };
  },
  mounted() {
    this.commissionInvestorList = this.commissionList.filter(
      commission => commission.profile === 'investor',
    );
    this.commissionTraderList = this.commissionList.filter(
      commission => commission.profile === 'trader',
    );
    this.commissionConsumerList = this.commissionList.filter(
      commission => commission.profile === 'consumer',
    );
  },
  methods: {
    /**
     * @param {T[]} list
     * @return {function(): number}
     */
    getQuantityItemInList(list) {
      return list.length;
    },
    /**
     * @param {string} property
     * @param {T[]} list
     * @return {function(): number}
     */
    sumColumn(property, list) {
      return sumColumnValueByListAndColumn(property, list);
    },
  },
};
</script>

<style lang="scss" scoped>
.comission-counter {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  .profile-title {
    font-weight: 700;
  }
  .content {
    display: flex;
    gap: 0.5rem;
  }
}
</style>
